export enum CheckboxFormat {
    OptIn = 0,
    OptOut = 1
}
